













































































import Vue from "vue";
import Header from "@/components/Header.vue";
import { PnetInput } from "@previnet/vue-input";
import { RequestService } from "@/services";
import LoginService from "../services/login";

const requestService = new RequestService();
const loginService = new LoginService();

const handleResponse = (response: Response) => {
  if (!response.ok) {
    // TODO handle errori
  } else {
    return response.json();
  }
};

export default Vue.extend({
  props: ["user", "homeRoute"],
  components: {
    Header,
    PnetInput,
  },
  data: function() {
    return {
      loggedUser: this.$props.user,
      changePassword: {
        oldPassword: "",
        newPassword: "",
        newPasswordConfirm: ""
      },
      labels: {
        oldPassword: "Vecchia password",
        newPassword: "Nuova password",
        newPasswordConfirm: "Conferma nuova password"
      },
      passwordHints: [],
      modalTitle: '',
      modalMsg: '',
      modalHints: [],
      passwordChanged: false,
      needsChangePassword: false,
      passwordForgotten: false,
    };
  },
  methods: {
    cambiaPassword: async function() {
      const vm = this as any;
      vm.startLoading();

      const handle = function(result: any) {
        vm.passwordChanged = result.changed;
        if (vm.passwordChanged) {
          vm.getUser();
          vm.openModal('Successo', 'Password cambiata con successo!\nPer cortesia, effettua nuovamente l\'accesso usando la nuova password.', []);
        } else {
          vm.openModal('Errore', 'La password non è stata cambiata!', result.errors);
        }
      };

      if (vm.passwordForgotten) {
        const params = {
          token: vm.loggedUser.passwordForgottenToken,
          newPassword: vm.changePassword.newPassword,
          newPasswordConfirm: vm.changePassword.newPasswordConfirm,
        };
        const serviceCallReturnValue = await requestService.changePasswordForgotten(params)
          .then(handleResponse)
          .then((result: any) => {
            handle(result);
          });
      } else {
        const serviceCallReturnValue = await requestService.changePassword(vm.changePassword)
          .then(handleResponse)
          .then((result: any) => {
            handle(result);
          });
      }

      vm.stopLoading();
    },
    getUser: async function() {
      const vm = this as any;
      const serviceCallReturnValue = await requestService.getUser()
        .then(handleResponse)
        .then((result: any) => {
          vm.loggedUser = result;
        });
    },
    getPasswordHints: async function() {
      const vm = this as any;
      const serviceCallReturnValue = await requestService.getPasswordHints()
        .then(handleResponse)
        .then((result: any) => {
          vm.passwordHints = result;
        });
    },
    openModal(title: string, msg: string, hints: any) {
      const vm = this as any;
      vm.modalTitle = title;
      vm.modalMsg = msg;
      vm.modalHints = hints;
      vm.$bvModal.show("modal-cambio-password");
    },
    closeModal() {
      const vm = this as any;
      vm.$bvModal.hide("modal-cambio-password");
      if (vm.passwordChanged) {
        vm.doLogout();
      }
    },
    onClickModal() {
      const vm = this as any;
      vm.closeModal();
    },
    home: function() {
      const vm = this as any;
      var route = vm.$props.homeRoute;
      if (route === undefined) {
        route = 'home';
      }
      vm.$router.push({ name: route, params: {user: vm.loggedUser}});
    },
    doLogout: async function() {
      const vm = this as any;
      const serviceCallReturnValue = await loginService.doLogout() 
        .then((result) => {
          vm.$router.push({ name: 'login'});
          return null;
        })
        .catch(function(e) {
          console.log("Errore generico");
        });
    },
    startLoading() {
      const vm = this as any;
      vm.$loadingService.startLoading("loading");
    },
    stopLoading() {
      const vm = this as any;
      vm.$loadingService.stopLoading("loading");
    },
  },
  created() {
    const vm = this as any;
    if (vm.$props.user == undefined) {
      vm.getUser();
    }
    if (vm.loggedUser) {
      vm.passwordForgotten = vm.loggedUser.passwordForgotten;
      vm.needsChangePassword = vm.loggedUser.firstAccess || vm.loggedUser.passwordExpired || vm.loggedUser.passwordForgotten;
    }
    vm.getPasswordHints();
  }
});
